import React from 'react';
import { makeStyles } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import InfoIcon from '@material-ui/icons/Info';
import { MD_MEDIA_QUERY } from '../../common/constants';

const useStyles = makeStyles(() => ({
  iconButton: {
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    top: '-8px',
  },
  infoIcon: {
    color: 'orange',
    zIndex: 2,
  },
  infoCircle: {
    backgroundColor: 'white',
    borderRadius: '50%',
    position: 'absolute',
    zIndex: 1,
  },
}));

interface IProps {
  visible: boolean;
  zoom: number;
  toggleTooltip: () => void;
}

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
const Info = (props: IProps) => {
  const screenWidthIsLessThanOrEqualToMdBreakpoint = useMediaQuery(MD_MEDIA_QUERY);
  const { visible, zoom } = props;
  const iconSize = screenWidthIsLessThanOrEqualToMdBreakpoint ? 12 : zoom * 14;
  // Right position from the block or group block
  const rightPosition = screenWidthIsLessThanOrEqualToMdBreakpoint ? 20 : zoom * 20;
  const classes = useStyles();

  if (!visible) return null;
  return (
    <IconButton
      className={classes.iconButton}
      style={{
        right: `-${rightPosition}px`,
        width: `${iconSize}px`,
        height: `${iconSize}px`,
      }}
      onClick={() => props.toggleTooltip()}
    >
      <InfoIcon
        className={classes.infoIcon}
        style={{
          width: `${iconSize}px`,
          height: `${iconSize}px`,
        }}
      />
      <div
        className={classes.infoCircle}
        style={{
          minWidth: `${iconSize * 0.8}px`,
          minHeight: `${iconSize * 0.8}px`,
        }}
      />
    </IconButton>
  );
};

// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default Info;
